import { getApiMaintenanceGlobal } from "./auth";
import { ERRORS } from "../consts";
import type { Roles } from "../types";

export async function getMaintenanceStatus({ userRoles, idToken, sessionToken }:
                                           {userRoles: Roles[] | undefined, idToken: string, sessionToken: string}) {

  try {
    const isPO = userRoles?.includes("PRODUCT_OWNER");

    // POs don't need check maintenance
    if (isPO) {
      return false;
    }
    const newMaintenanceStatus = await getApiMaintenanceGlobal({
      accessToken: idToken,
      sessionToken : sessionToken || "" });
    return newMaintenanceStatus.showMaintenancePage;
  } catch (err) {
    // Propaga gli errori di autorizzazione invece di nasconderli
    if (err === ERRORS.UNAUTHORIZED) {
      throw err;
    }
    // Per altri errori, ritorna false come prima
    return false;
  }

}
